module.exports = __webpack_public_path__ + "img/instructions.bd5abd05.png";